export default "__VITE_PUBLIC_ASSET__1fc2e2c3__"